import React from 'react';

export const TennisBallSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6933_3039)">
          <path fill-rule="evenodd" clipRule="evenodd" d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36ZM27 17.9992C27 11.9512 28.792 7.77822 31.802 6.45322C31.357 5.92222 30.876 5.42522 30.374 4.94922C27.406 6.60422 25 10.5772 25 17.9992C25 25.4202 27.406 29.3942 30.374 31.0492C30.876 30.5732 31.358 30.0762 31.802 29.5452C28.792 28.2202 27 24.0472 27 17.9992ZM9 18C9 11.952 7.208 7.77999 4.198 6.45399C4.642 5.92299 5.124 5.42699 5.626 4.95099C8.594 6.60499 11 10.579 11 18C11 25.421 8.593 29.395 5.626 31.05C5.124 30.573 4.643 30.077 4.198 29.546C7.208 28.22 9 24.048 9 18Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_6933_3039">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5996_18665)">
        <path d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z" fill={window?.settings?.primary_color ?? '#1DBD6B'} />
        <path d="M26 17.9991C26 24.0471 28.792 28.2201 31.802 29.5451C34.42 26.4191 36 22.3951 36 17.9991C36 13.6031 34.42 9.57912 31.802 6.45312C28.792 7.77813 26 11.9511 26 17.9991Z" fill="#61D197" />
        <path d="M27 17.9992C27 11.9512 28.792 7.77822 31.802 6.45322C31.357 5.92222 30.876 5.42522 30.374 4.94922C27.406 6.60422 25 10.5772 25 17.9992C25 25.4202 27.406 29.3942 30.374 31.0492C30.876 30.5732 31.358 30.0762 31.802 29.5452C28.792 28.2202 27 24.0472 27 17.9992Z" fill="white" />
        <path d="M10 17.9991C10 11.9511 7.208 7.77912 4.198 6.45312C1.58 9.57912 0 13.6031 0 17.9991C0 22.3951 1.58 26.4191 4.198 29.5451C7.208 28.2191 10 24.0471 10 17.9991Z" fill="#61D197" />
        <path d="M4.19824 6.45399C7.20824 7.77999 9.00024 11.952 9.00024 18C9.00024 24.048 7.20824 28.22 4.19824 29.546C4.64324 30.077 5.12424 30.573 5.62624 31.05C8.59324 29.395 11.0002 25.421 11.0002 18C11.0002 10.579 8.59424 6.60499 5.62624 4.95099C5.12424 5.42699 4.64224 5.92299 4.19824 6.45399Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_5996_18665">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}